import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  pictures: [],
};

const getters = {
  getPictures: (state) => state.pictures,
  getPictureById: (state) => (id) => state.pictures.find((x) => x.id == id),
};

const actions = {
  async fetchPictures({ commit }) {
    try {
      const resp = await api.get("/pictures");
      //console.log("resp_pics", resp);
      if (resp.status == 200) {
        const pictures = resp.data.data;
        commit("setPictures", pictures);
      }
      return true;
    } catch (error) {
      //console.log("error: pix", error);
      return false;
    }
  },
  async updatePicture({ commit }, picture) {
    //console.log("pic::", picture);
    try {
      const formData = new FormData();
      formData.append("url", picture.url);
      formData.append("_method", "patch");
      formData.append("name", picture.name);

      const resp = await api.post(`/pictures/${picture.id}`, formData);
      if (resp.status == 200) {
        const picture = resp.data.data;
        commit("updatePicture", picture);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async addPicture({ commit }, picture) {
    try {
      const formData = new FormData();
      formData.append("url", picture.url);

      formData.append("name", picture.name);
      const resp = await api.post(`/pictures`, formData);

      if (resp.status == 201) {
        const picture = resp.data.data;

        commit("addPicture", picture);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deletePicture({ commit }, id) {
    try {
      const resp = await api.delete(`/pictures/${id}`);
      if (resp.status == 204) {
        commit("deletePicture", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setPictures(state, pictures) {
    //console.log("pix", pictures);
    state.pictures = pictures;
  },
  updatePicture(state, picture) {
    const id = picture.id;
    const index = state.pictures.findIndex((picture) => picture.id == id);
    if (index !== -1) {
      state.pictures[index] = picture;
    }
  },
  addPicture(state, picture) {
    state.pictures.unshift(picture);
  },

  deletePicture(state, id) {
    const index = state.pictures.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.pictures.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
